export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost/api/v1';

export const STATUS_ATENDIMENTO = {
  ABERTO: 'aberto',
  COTACAO: 'cotacao',
  ACIONADO: 'acionado',
  EM_ATENDIMENTO: 'em_atendimento',
  FINALIZADO: 'finalizado',
  CANCELADO: 'cancelado',
};

export const NIVEIS_OPERADOR = {
  ADMIN: 'admin',
  SUPERVISOR: 'supervisor',
  OPERADOR: 'operador',
};

export const STATUS_LABELS = {
  ativo: 'Ativo',
  inativo: 'Inativo',
  ativa: 'Ativa',
  inativa: 'Inativa',
  aberto: 'Aberto',
  cotacao: 'Cotação',
  acionado: 'Acionado',
  em_atendimento: 'Em Atendimento',
  finalizado: 'Finalizado',
  cancelado: 'Cancelado',
  pendente: 'Pendente',
  aprovado: 'Aprovado',
  suspenso: 'Suspenso',
  confirmado: 'Confirmado',
  vencido: 'Vencido',
  estornado: 'Estornado',
  carencia: 'Carência',
};

export const STATUS_COLORS = {
  ativo: '#16a34a',
  inativo: '#dc2626',
  ativa: '#16a34a',
  inativa: '#dc2626',
  aberto: '#2563eb',
  cotacao: '#f59e0b',
  acionado: '#8b5cf6',
  em_atendimento: '#f97316',
  finalizado: '#16a34a',
  cancelado: '#dc2626',
  pendente: '#f59e0b',
  aprovado: '#16a34a',
  suspenso: '#dc2626',
  confirmado: '#16a34a',
  carencia: '#f59e0b',
};

export const SUB_STATUS_LABELS = {
  analisando: 'Analisando',
  localizando_prestador: 'Localizando Prestador',
  em_cotacao: 'Em Cotação',
  prestador_localizado: 'Prestador Localizado',
  prestador_acionado: 'Prestador Acionado',
  prestador_cancelou: 'Prestador Cancelou',
  localizando_novo_prestador: 'Localizando Novo Prestador',
  novo_prestador_localizado: 'Novo Prestador Localizado',
  novo_prestador_acionado: 'Novo Prestador Acionado',
};

export const SUB_STATUS_COLORS = {
  analisando: '#3b82f6',
  localizando_prestador: '#f59e0b',
  em_cotacao: '#f59e0b',
  prestador_localizado: '#10b981',
  prestador_acionado: '#8b5cf6',
  prestador_cancelou: '#ef4444',
  localizando_novo_prestador: '#f59e0b',
  novo_prestador_localizado: '#10b981',
  novo_prestador_acionado: '#8b5cf6',
};

export const PREVIA_STATUS = {
  ok: { label: 'Previa Ok', color: '#16a34a', bg: '#dcfce7' },
  alerta: { label: 'Alerta Previa', color: '#f59e0b', bg: '#fef3c7' },
  atrasada: { label: 'Previa Atrasada', color: '#dc2626', bg: '#fee2e2' },
  nova: { label: 'Nova Previa', color: '#2563eb', bg: '#dbeafe' },
};

export const PER_PAGE_OPTIONS = [10, 20, 50, 100];

export const MODULOS_PERMISSAO = {
  dashboard: { label: 'Dashboard', acoes: ['ver'] },
  clientes: { label: 'Beneficiarios', acoes: ['ver', 'criar', 'editar', 'excluir'] },
  veiculos: { label: 'Veiculos', acoes: ['ver', 'criar', 'editar', 'excluir'] },
  empresas: { label: 'Empresas', acoes: ['ver', 'criar', 'editar', 'excluir'] },
  servicos: { label: 'Servicos', acoes: ['ver', 'criar', 'editar', 'excluir'] },
  tipos_atendimento: { label: 'Tipos Atendimento', acoes: ['ver', 'criar', 'editar', 'excluir'] },
  planos: { label: 'Planos', acoes: ['ver', 'criar', 'editar', 'excluir'] },
  acionamentos: { label: 'Acionamentos', acoes: ['ver', 'criar'] },
  prestadores: { label: 'Prestadores', acoes: ['ver', 'criar', 'editar', 'excluir'] },
  operadores: { label: 'Operadores', acoes: ['ver', 'criar', 'editar'] },
  perfis: { label: 'Perfis', acoes: ['ver', 'criar', 'editar'] },
  fechamentos: { label: 'Fechamentos', acoes: ['ver'] },
  relatorios: { label: 'Relatorios', acoes: ['ver'] },
};

export const ACOES_LABELS = {
  ver: 'Visualizar',
  criar: 'Criar',
  editar: 'Editar',
  excluir: 'Excluir',
};

export const TIMEZONES = [
  { value: 'America/Sao_Paulo', label: 'Brasilia (BRT, UTC-3)' },
  { value: 'America/Manaus', label: 'Manaus (AMT, UTC-4)' },
  { value: 'America/Cuiaba', label: 'Cuiaba (AMT, UTC-4)' },
  { value: 'America/Belem', label: 'Belem (BRT, UTC-3)' },
  { value: 'America/Fortaleza', label: 'Fortaleza (BRT, UTC-3)' },
  { value: 'America/Recife', label: 'Recife (BRT, UTC-3)' },
  { value: 'America/Rio_Branco', label: 'Rio Branco (ACT, UTC-5)' },
  { value: 'America/Porto_Velho', label: 'Porto Velho (AMT, UTC-4)' },
  { value: 'America/Noronha', label: 'Noronha (FNT, UTC-2)' },
  { value: 'America/Boa_Vista', label: 'Boa Vista (AMT, UTC-4)' },
];

export const DEFAULT_TIMEZONE = 'America/Sao_Paulo';
